document.addEventListener("DOMContentLoaded", () => {

  /* ========================================
     GALLERY
  ======================================== */

  const mainImage =
    document.getElementById(
      "ProductV2MainImage"
    );

  const thumbs =
    document.querySelectorAll(
      ".product-v2__thumb"
    );

  let currentIndex = 0;

  function setActiveThumb(index) {

    thumbs.forEach((thumb) =>
      thumb.classList.remove(
        "is-active"
      )
    );

    thumbs[index].classList.add(
      "is-active"
    );

    mainImage.src =
      thumbs[index].dataset.image;

    currentIndex = index;

  }

  thumbs.forEach(
    (thumb, index) => {

      thumb.addEventListener(
        "click",
        () => {

          setActiveThumb(index);

        }
      );

    }
  );

  /* ========================================
     ARROWS
  ======================================== */

  const prevBtn =
    document.querySelector(
      ".product-v2__arrow--prev"
    );

  const nextBtn =
    document.querySelector(
      ".product-v2__arrow--next"
    );

  if (
    prevBtn &&
    nextBtn &&
    thumbs.length
  ) {

    prevBtn.addEventListener(
      "click",
      () => {

        let newIndex =
          currentIndex - 1;

        if (newIndex < 0) {

          newIndex =
            thumbs.length - 1;

        }

        setActiveThumb(
          newIndex
        );

      }
    );

    nextBtn.addEventListener(
      "click",
      () => {

        let newIndex =
          currentIndex + 1;

        if (
          newIndex >=
          thumbs.length
        ) {

          newIndex = 0;

        }

        setActiveThumb(
          newIndex
        );

      }
    );

  }

  /* ========================================
     QUANTITY
  ======================================== */

  const quantityWrap =
    document.querySelector(
      ".product-v2__quantity"
    );

  if (quantityWrap) {

    const input =
      quantityWrap.querySelector(
        'input[name="quantity"]'
      );

    const minus =
      quantityWrap.querySelector(
        ".qty-minus"
      );

    const plus =
      quantityWrap.querySelector(
        ".qty-plus"
      );

    minus.addEventListener(
      "click",
      () => {

        let value =
          parseInt(
            input.value
          ) || 1;

        if (value > 1) {

          input.value =
            value - 1;

        }

      }
    );

    plus.addEventListener(
      "click",
      () => {

        let value =
          parseInt(
            input.value
          ) || 1;

        input.value =
          value + 1;

      }
    );

  }

  /* ========================================
     VARIANT PILLS
  ======================================== */

  const pills =
    document.querySelectorAll(
      ".product-v2__variant-pill"
    );

  pills.forEach((pill) => {

    pill.addEventListener(
      "click",
      () => {

        const parent =
          pill.closest(
            ".product-v2__option-values"
          );

        parent
          .querySelectorAll(
            ".product-v2__variant-pill"
          )
          .forEach((item) =>
            item.classList.remove(
              "active"
            )
          );

        pill.classList.add(
          "active"
        );

      }
    );

  });

});

/* ========================================
   DYNAMIC VARIANTS
======================================== */

const variantsJson =
  document.getElementById(
    "ProductVariantsJson"
  );

if (variantsJson) {

  const variants =
    JSON.parse(
      variantsJson.textContent
    );

  const selectedOptions = {};

 function updateSelectedVariant() {

  const variant =
    variants.find(
      (variant) => {

        return (

          variant.option1 ===
            selectedOptions[1]

          &&

          variant.option2 ===
            selectedOptions[2]

        );

      }
    );

  if (!variant) {

    console.log(
      "No matching variant"
    );

    return;

  }

  console.log(
    "Selected Variant:",
    variant.title,
    variant.id,
    variant.available
  );

  const variantInput =
    document.getElementById(
      "ProductVariantId"
    );

  if (variantInput) {

    variantInput.value =
      variant.id;

  }

}

function updateSizeAvailability() {

  const selectedColor =
    selectedOptions[1];

  if (!selectedColor) return;

  document
    .querySelectorAll(
      '.product-v2__variant-pill[data-option-position="2"]'
    )
    .forEach((pill) => {

      const size =
        pill.dataset.optionValue;

      const variant =
        variants.find(
          (variant) =>

            variant.option1 ===
              selectedColor

            &&

            variant.option2 ===
              size

        );

      const available =
        variant &&
        variant.available;

      pill.disabled =
        !available;

      pill.classList.toggle(
        "is-sold-out",
        !available
      );

    });

}

function validateVariantSelection() {

  const addButton =
    document.querySelector(
      ".product-v2__add"
    );

  const totalOptions =
    document.querySelectorAll(
      ".product-v2__option"
    ).length;

  const selectedCount =
    Object.keys(
      selectedOptions
    ).length;

  addButton.disabled =
    selectedCount <
    totalOptions;

}

document
  .querySelector(
    ".product-v2__add"
  )
  .disabled = true;

  document
    .querySelectorAll(
      ".product-v2__variant-pill"
    )
    .forEach((pill) => {

      pill.addEventListener(
        "click",
        () => {

          const position =
            Number(
              pill.dataset.optionPosition
            );

          selectedOptions[
            position
          ] =
            pill.dataset.optionValue;

            console.log(selectedOptions);

          updateSelectedVariant();
          updateSizeAvailability();
          validateVariantSelection();

        }
      );

    });

}